// extracted by mini-css-extract-plugin
export default {"isLegit":"SymbolInput_isLegit__Ck+ng","isNotLegit":"SymbolInput_isNotLegit__a7jrQ"};